import { render } from "./PopUpPromo.vue?vue&type=template&id=558a62d4&scoped=true"
import script from "./PopUpPromo.vue?vue&type=script&lang=js"
export * from "./PopUpPromo.vue?vue&type=script&lang=js"

import "./PopUpPromo.vue?vue&type=style&index=0&id=558a62d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558a62d4"]])

export default __exports__